module.exports = __webpack_public_path__ + "img/mil.0caf9bb4.jpg";